(function () {
  function initComingSoon() {
    document.querySelectorAll('[id^="coming-soon-wrapper-"]').forEach(function (wrapper) {
      const sectionId = wrapper.dataset.sectionId;
      const productComingSoon = wrapper.dataset.productComingSoon === 'true';
      const productRelease = parseInt(wrapper.dataset.productRelease, 10);
      const productReleaseDisplay = wrapper.dataset.productReleaseDisplay;

      const variantsDataEl = document.getElementById('variants-release-' + sectionId);
      const variantsData = variantsDataEl ? JSON.parse(variantsDataEl.textContent) : {};

      const comingSoonBtn = document.getElementById('coming-soon-btn-' + sectionId);
      const addToCartBtn = document.getElementById('ProductSubmitButton-' + sectionId);
      const dateEl = document.getElementById('coming-soon-date-' + sectionId);
      const timerEl = document.getElementById('coming-soon-timer-' + sectionId);

      let intervalId = null;

      function pad(n) {
        return String(Math.max(0, n)).padStart(2, '0');
      }

      function tick(releaseTime) {
        const diff = releaseTime - Date.now();
        if (diff <= 0) {
          comingSoonBtn.style.display = 'none';
          if (addToCartBtn) addToCartBtn.style.display = '';
          if (intervalId) clearInterval(intervalId);
          return;
        }
        const hours   = Math.floor(diff / 3600000);
        const minutes = Math.floor((diff % 3600000) / 60000);
        const seconds = Math.floor((diff % 60000) / 1000);
        timerEl.textContent = '発売まで ' + hours + ': ' + pad(minutes) + ': ' + pad(seconds) + '';
      }

      function updateButton(variantId) {
        if (intervalId) clearInterval(intervalId);

        const variantData = variantsData[String(variantId)] || {};
        const isVariantComingSoon = variantData.coming_soon === true;

        let releaseTime = 0;
        let releaseDisplay = '';
        let shouldShow = false;

        // 商品タグ coming-soon
        if (productComingSoon) {
          shouldShow = true;
          releaseTime = productRelease || 0;
          releaseDisplay = productReleaseDisplay || '';
        }

        // バリアントメタフィールド coming_soon = true
        if (isVariantComingSoon) {
          shouldShow = true;
          if (variantData.timestamp && variantData.timestamp > 0) {
            releaseTime = variantData.timestamp;
            releaseDisplay = variantData.display || '';
          } else if (productRelease > 0) {
            releaseTime = productRelease;
            releaseDisplay = productReleaseDisplay || '';
          }
        }

        if (shouldShow) {
          comingSoonBtn.style.display = 'flex';
          if (addToCartBtn) addToCartBtn.style.display = 'none';

          if (releaseTime > 0 && releaseTime > Date.now()) {
            // 日時あり → 日時＋カウントダウン表示
            dateEl.textContent = releaseDisplay + ' 発売';
            tick(releaseTime);
            intervalId = setInterval(function () { tick(releaseTime); }, 1000);
          } else {
            // 日時なし → COMING SOONのみ
            dateEl.textContent = 'COMING SOON';
            timerEl.textContent = '';
          }
        } else {
          comingSoonBtn.style.display = 'none';
          if (addToCartBtn) addToCartBtn.style.display = '';
        }
      }

      // 初期表示
      const variantInput = document.querySelector('[name="id"]');
      if (variantInput) {
        updateButton(parseInt(variantInput.value, 10));
      }

      // バリアント切替時（FoxTheme pubsub）
      if (window.FoxTheme && FoxTheme.pubsub) {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, function (event) {
          if (event.data && event.data.variant) {
            updateButton(event.data.variant.id);
          }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initComingSoon);
  } else {
    initComingSoon();
  }
})();
